import React from 'react';
import bemify from 'bemify-js';

import BashCodeBlock from '../components/BashCodeBlock';
import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('run-login');

const RunLogin = () => (
  <div className={bem()}>
    <StepTitle>Run Zapier Login</StepTitle>
    <Paragraph>
      Let's configure authentication between your dev environment and the Zapier
      platform. You'll use the email address and password you use to log in to
      the Zapier application.
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier login',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>
      This command will set up a <Code>.zapierrc</Code> file in your home
      directory.
    </Paragraph>
  </div>
);

export default RunLogin;
